import type { JSX } from "preact";
import { Redirect, Route, Router, Switch } from "wouter-preact";
import { Auth } from "@gss/common/Auth";
import { resultsPaths as paths } from "@gss/common/Paths";
import { LoadingBar } from "@gss/components/LoadingBar";
import { Messages, useMessages } from "@gss/components/Messages";
import { Export } from "./export/Export";
import { Exports } from "./export/Exports";
import { Summary } from "./export/Summary";
import { Measurement } from "./Measurement";
import { Measurements } from "./Measurements";
import { Menu } from "./menu/Menu";
import { getBaseName } from "./util/getBaseName";
import { useTranslation } from "./util/Translation";

interface Props {
    disableRoutes: boolean;
}

export function App({ disableRoutes }: Props): JSX.Element {
    const t = useTranslation().translation.error;
    const { addError } = useMessages();

    Auth.onAuthRefreshError((cause) => {
        addError({
            message: t.authRefresh,
            cause,
        });
    });

    const renderRoutses = () => {
        if (disableRoutes) {
            return null;
        }
        return (
            <Switch>
                <Route path={paths.exports} component={Exports} />
                <Route path={paths.export} component={Export} />
                <Route path={paths.summary} component={Summary} />
                <Route path={paths.measurement} component={Measurement} />
                <Route path={paths.measurements} component={Measurements} />
                <Redirect href={paths.measurements} replace />
            </Switch>
        );
    };

    return (
        <Router base={getBaseName()}>
            <Menu />
            <LoadingBar />
            <main>
                <Messages closeText={t.closeMessage} />
                {renderRoutses()}
            </main>
        </Router>
    );
}
